import debug from 'debug'

const logger = debug('optimizely')

export const optimizelyLogger = (level, message) => {
  logger(message)
}
